import classnames from "classnames";
import { ErrorMessage } from "formik";
import { Input } from "antd";
import { MdErrorOutline } from "react-icons/md";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";

/* eslint-disable react/prop-types */
const PasswordInput = ({
  type = "text",
  title,
  name,
  placeholder,
  requiredField = false,
  errors,
  values,
  handleChange,
  handleBlur,
  touched,
  readOnly = false,
  icon,
}) => {
  return (
    <div className="mb-4">
      <label
        htmlFor={name}
        className="block leading-6 text-gray-500 mb-2 text-sm"
      >
        {title}
        {requiredField && <span className="text-red-800 mx-1">*</span>}
      </label>
      <div>
        <Input.Password
          size="small"
          iconRender={(visible) =>
            visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
          }
          id={name}
          name={name}
          readOnly={readOnly}
          type={type}
          placeholder={placeholder}
          onChange={handleChange(name)}
          onBlur={handleBlur(name)}
          value={values[name]}
          autoComplete="off"
          prefix={icon && icon}
          className={classnames(
            "h-[36px] flex w-full  border-0 py-[6px] text-gray-500 ring-1 ring-gray-30/30  placeholder:text-gray-400 placeholder:font-light focus:ring-inset  text-sm sm:leading-6",
            errors && errors[name] && touched && touched[name]
              ? "ring-red-600 focus:ring-red-600 text-red-600"
              : "ring-gray-200/10 focus:ring-primary-dark"
          )}
        />
      </div>

      <ErrorMessage name={name}>
        {(msg) => (
          <div className="text-xs text-red-500 text-left w-full flex gap-1 items-center mt-1">
            <MdErrorOutline size={16} />
            <p className="text-xs">{msg}</p>
          </div>
        )}
      </ErrorMessage>
    </div>
  );
};

export default PasswordInput;
